import type { PortableTextComponents } from '@portabletext/vue'
import { h } from 'vue'
import SanityImage from '@core/components/sanity-image/index.vue'

export const components: PortableTextComponents = {
  block: {
    footnote: (_, { slots }) => {
      return h('p', { class: 'footnote' }, slots.default?.())
    },
  },
  types: {
    Image: (props) => {
      return h(SanityImage, { class: 'block-img', image: props.value })
    },
    InvalidPlaceholder: () => {
      return h('img', {
        class: 'cursor-pointer icon h-5 p-1 border border-dotted hover:border-black',
        src: '/images/missing-data.svg',
        alt: 'Data is not available',
        'data-tooltip-content': 'errors.invalid_placeholder',
      })
    },
  },
  marks: {
    highlight: (_, { slots }) => {
      return h('span', { class: 'highlight' }, slots.default?.())
    },
    link: (props, { slots }) => {
      const { redirectUrl } = useRuntimeConfig().public
      const href = addAffiliateMobileAppParams(props.value.href)
      const target = props.value.targetBlank ? '_blank' : undefined
      const rel = props.value.href.includes(redirectUrl) ? 'noopener nofollow' : 'noopener'
      return h('a', { href, target, rel }, slots.default?.())
    },
    tooltip: (props, { slots }) => {
      return h(
        'span',
        {
          class: 'inline-block cursor-pointer dotted-underline',
          'data-tooltip-content': props.value.content,
        },
        slots.default?.(),
      )
    },
  },
}
